<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <Aguarde :show="showAguarde"></Aguarde>
    <div class="row">
      <div v-if="entidade.par_tipo_cobranca !== '99'" class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div v-if="entidade.par_tipo_cobranca === '1'" class="col-xl-4 col-md-6 col-sm-6"><label
                  for="pay-retorno-pix" class="card-radio-label mb-3">
                <input type="radio" name="pay-method"
                       @change="alterFilter(true)"
                       id="pay-retorno-pix"
                       :value="true"
                       v-model="filtros.pix"
                       v-bind:checked="filtros.pix"
                       class="card-radio-input">
                <div class="card-radio"><i class="fas fa-qrcode font-size-24 text-dark align-middle mr-2"></i>
                  <span>Pagamentos por Pix</span>
                </div>
              </label>
              </div>
              <div v-if="entidade.par_tipo_cobranca === '2'" class="col-xl-4 col-md-6 col-sm-6"><label
                  for="pay-retorno-boleto" class="card-radio-label mb-3">
                <input type="radio" name="pay-method"
                       @change="alterFilter(false)"
                       id="pay-retorno-boleto"
                       :value="true"
                       v-model="filtros.boleto"
                       v-bind:checked="filtros.boleto"
                       class="card-radio-input">
                <div class="card-radio">
                  <i class="fas fa-barcode font-size-24 text-dark align-middle mr-2"></i>
                  <span>Pagamentos por Boletos</span>
                </div>
              </label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <b-form>
                  <div class="row">
                    <div class="col-md-3">
                      <b-form-group
                          label="Código"
                          label-for="codigo">
                        <input
                            id="codigo"
                            v-model="filtros.codigo"
                            type="text"
                            maxlength="10"
                            class="form-control"
                            placeholder="Exemplo: 48">
                        <div class="font-size-11 text-muted mt-1 mb-0">
                          Sem os zeros à esquerda
                        </div>
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group
                          label="Nome/Razão Social"
                          label-for="pes_nome">
                        <input
                            id="pes_nome"
                            v-model="filtros.pes_nome"
                            type="text"
                            maxlength="200"
                            class="form-control"
                            placeholder="">
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group label-for="vencimento_inicio" label="Vencimento Início">
                        <input
                            id="vencimento_inicio"
                            v-model="filtros.vencimento_inicio"
                            type="date"
                            class="form-control"
                            placeholder="">
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group
                          label-for="vencimento_fim"
                          label="Vencimento Fim">
                        <input
                            id="vencimento_fim"
                            v-model="filtros.vencimento_fim"
                            type="date"
                            class="form-control"
                            placeholder="">
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <b-form-group label="Status" label-for="filtros-status">
                        <select id="filtros-status"
                                v-model="filtros.status"
                                class="custom-select" type="text">
                          <option value="">Todos</option>
                          <option value="9999">Aguardando Pagamento ou Em Liquidação</option>
                          <option value="1">Aguardando Pagamento</option>
                          <option value="14">Em Liquidação</option>
                          <option value="6">Pago</option>
                          <option value="7">Baixado</option>
                          <option value="100">Cancelado</option>
                        </select>
                      </b-form-group>
                    </div>
                  </div>
                </b-form>
              </div>
            </div>
          </div>
        </div>
        <table-retorno-pix v-if="filtros.pix" :filtro="filtros"></table-retorno-pix>
        <table-retorno-boleto v-if="filtros.boleto" :filtro="filtros"></table-retorno-boleto>
      </div>
      <div v-else class="col-12">
        <span>Sem Convênio On-line</span>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "@/router/layouts/main";
import Aguarde from "@/components/widgets/aguarde";
import appConfig from "@/dados/app.config.json";
import PageHeader from "@/components/page-header";
import TableRetornoPix from "@/router/views/admin/components/gestao/table-retorno-pix"
import TableRetornoBoleto from "@/router/views/admin/components/gestao/table-retorno-boleto"
import {getFimAno, getInicoAno} from "@/helps/util";

export default {
  page: {
    title: "Retorno de Pagamento",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Aguarde,
    TableRetornoPix,
    TableRetornoBoleto
  },
  data() {
    return {
      title: "Retorno de Pagamento",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Retorno de Pagamento',
          active: true,
        },
      ],
      showAguarde: false,
      httpSend: false,
      filtros: {
        pix: true,
        boleto: false,
        codigo: "",
        pes_nome: "",
        vencimento_inicio: getInicoAno(),
        vencimento_fim: getFimAno(),
        status: '9999'
      }
    };
  },
  created() {
    if (this.entidade.par_tipo_cobranca === '2') {
      this.filtros.boleto = true
      this.filtros.pix = false
    }
  },
  computed: {
    entidade: {
      get: function () {
        return this.$store.state.auth.currentEntidade;
      },
    },
  },
  methods: {
    alterFilter(tipo) {
      if (tipo) {
        this.filtros.pix = true;
        this.filtros.boleto = false;
      } else {
        this.filtros.pix = false;
        this.filtros.boleto = true;
      }
    },
  }
};
</script>


